<template>
  <div class="home">
    <Top></Top>
    <el-carousel height="860px" arrow="never">
      <el-carousel-item v-for="item in imgs" :key="item.url">
        <img @click="topage(item.num)" class="lunbo" :src="item.url" />
      </el-carousel-item>
    </el-carousel>

    <Mid></Mid>
    <Device></Device>
    <Hexinyoushi></Hexinyoushi>
    <Solution></Solution>
    <AboutUs></AboutUs>
    <Last></Last>
  </div>
</template>

<script>
import Top from "../../components/banner/index.vue";
import Mid from "../../components/home/Mid.vue";
import Device from "../../components/home/device.vue";
import Hexinyoushi from "../../components/home/hexinyoushi.vue";
import Solution from "@/components/home/Solution.vue";
import AboutUs from "@/components/home/aboutUs.vue";
import Last from "@/components/last/index.vue";
export default {
  name: "HomeView",
  components: { Top, Mid, Device, Hexinyoushi, Solution, AboutUs, Last },
  data() {
    return {
      imgs: [
        { url: require("../../assets/banner1.png"), num: 1, path: "/aboutus" },
        {
          url: require("../../assets/banner2.jpg"),
          num: 2,
          path: "/production/fqd",
        },
        {
          url: require("../../assets/banner3.jpg"),
          num: 3,
          path: "/production/yccb",
        },
        {
          url: require("../../assets/banner4.jpg"),
          num: 4,
          path: "/production/BMS",
        },
      ],
      show: true,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      topBannerNavBg: {
        backgroundColor: "",
      },
    };
  },
  mounted() {
    //监听scroll滑动事件
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    //scroll事件
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop) {
        this.topBannerNavBg.backgroundColor = "#1e232f"; // scrollTop + 多少根据自己的需求设置
      } else if (scrollTop === 0) {
        this.topBannerNavBg.backgroundColor = "transparent"; // 设置回到顶部时，背景颜色为透明
      }
    },
    topage(num) {
      this.imgs.forEach((item) => {
        if (num == item.num) {
          this.$router.push(item.path);
        } else {
        }
      });
    },
    //首页点击
    home() {
      this.show = true;
      this.show2 = false;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    },
    production() {
      this.show = false;
      this.show2 = true;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    },
    solution() {
      this.show = false;
      this.show2 = false;
      this.show3 = true;
      this.show4 = false;
      this.show5 = false;
    },
    application() {
      this.show = false;
      this.show2 = false;
      this.show3 = false;
      this.show4 = true;
      this.show5 = false;
    },
    aboutUs() {
      this.show = false;
      this.show2 = false;
      this.show3 = false;
      this.show4 = false;
      this.show5 = true;
      this.$router.push({ path: "/aboutus" });
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 1500px;
  margin-top: -100px;
  .lunbo {
    width: 100%;
    height: 860px;
  }
}
</style>
